var base = require('settings/teams/team-members');

Vue.component('spark-team-members', {
    mixins: [base],

    methods: {

        /**
         * Determine if the current user can edit a team member.
         */
        canEditTeamMember(member) {
            return this.user.id === this.team.owner_id && this.user.id !== member.id || this.spark.userIsTeamSuperUser && this.user.id !== member.id && this.team.owner_id !== member.id
        },

    },
});


